import { useState } from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { AuditPanel, CollaboratorsPanel, LeadsOverviewPanel, RulesPanel, SettingsPanel, TableRatesPanel } from "./adminpanels";

/** Administração do atendimento humano (admin max): equipe e caixa, comissões, leads e auditoria. */
export function HumanSalesAdmin() {
    const [tab, setTab] = useState('team');
    return (
        <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList variant="scrollable" scrollButtons="auto" onChange={(_, v) => setTab(v)}>
                    <Tab label="Equipe e caixa" value="team" />
                    <Tab label="% por situação" value="rules" />
                    <Tab label="Taxas de tabela" value="rates" />
                    <Tab label="Leads" value="leads" />
                    <Tab label="Configurações" value="settings" />
                    <Tab label="Auditoria" value="audit" />
                </TabList>
            </Box>
            <TabPanel value="team"><CollaboratorsPanel /></TabPanel>
            <TabPanel value="rules"><RulesPanel /></TabPanel>
            <TabPanel value="rates"><TableRatesPanel /></TabPanel>
            <TabPanel value="leads"><LeadsOverviewPanel /></TabPanel>
            <TabPanel value="settings"><SettingsPanel /></TabPanel>
            <TabPanel value="audit"><AuditPanel /></TabPanel>
        </TabContext>
    );
}
